import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';

export const Header = props => {
  return <LazyLoaderWrapper testId='header-container-test' importPath='HEADER_CONTAINER' {...props} />;
};

export const SecondaryHeader = props => {
  return <LazyLoaderWrapper testId='header-container-test' importPath='SECONDARY_HEADER_CONTAINER' {...props} />;
};
